import { html } from 'lit';
import { query, customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_ON_DEMAND_SCAN_CREDENTIALS_FORM } from '../../../../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { styles } from '../view/styles';
import { GzFormFieldWebComponent } from '../../../../../../../../../ui/gzForm/formField';
import { RequiredValidator } from '../../../../../../../../../ui/gzForm/validators/required.validator';
import { FormGroup } from '../../../../../../../../../ui/gzForm/formGroup/form-group';
import { InputWidthValues } from '../../../../../../../../../ui/gzInput';
import { GzPolicyFullPageWindowFormWebComponent } from '../../../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/form';
import { FontSizes, FontWeights } from '../../../../../../../../../types/common/types';
import { ExchangeAntimalwareOnDemandScanCredentials } from '@nirvana/shared/dtos/types/policies/common';
import { GzInputWebComponent } from '../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { MaxLengthValidator } from '../../../../../../../../../ui/gzForm/validators/max-length.validator';
import { ON_DEMAND_USERNAME_MAX_LENGTH } from '../../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { CustomizableValidator } from '../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { activeDirectoryUsername } from '../utils/validators';
import { EmailValidator } from '../../../../../../../../../ui/gzForm/validators/email.validator';
import _ from 'lodash';

@customElement(WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_ON_DEMAND_SCAN_CREDENTIALS_FORM)
export class GzExchangeAntimalwareOnDemandScanCredentialsFormWebComponent extends GzPolicyFullPageWindowFormWebComponent<ExchangeAntimalwareOnDemandScanCredentials> {
  @query('#exchange-antimalware-username-form-field')
  private antimalwareUsernameFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#exchange-antimalware-password-form-field')
  private antimalwarePasswordFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#exchange-antimalware-email-form-field')
  private antimalwareEmailFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#exchange-antimalware-ews-url-form-field')
  private antimalwareEwsUrlFormField: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public constructor(value?: ExchangeAntimalwareOnDemandScanCredentials) {
    super(value);
  }

  static get styles() {
    return styles;
  }

  public setError(error: string) {}

  protected getConvertedFormValue(): any {
    return _.cloneDeep(this.formGroup.value);
  }

  createFormGroup(): void {
    this.antimalwareUsernameFormField.Validators = [
      RequiredValidator(translateFn('Required field')),
      MaxLengthValidator(
        ON_DEMAND_USERNAME_MAX_LENGTH,
        translateFn('The username must have a maximum of {maxLength} characters.', {
          maxLength: ON_DEMAND_USERNAME_MAX_LENGTH,
        })
      ),
      CustomizableValidator(activeDirectoryUsername),
    ];
    this.antimalwarePasswordFormField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.antimalwareEmailFormField.Validators = [EmailValidator(translateFn('Invalid email address'))];

    this.formGroup = FormGroup.build({
      username: this.antimalwareUsernameFormField,
      password: this.antimalwarePasswordFormField,
      email: this.antimalwareEmailFormField,
      ewsUrl: this.antimalwareEwsUrlFormField,
    });
  }

  setFormGroupValue() {
    if (!this.value) {
      return;
    }

    this.formGroup.value = {
      username: this.value.username,
      password: this.value.password,
      email: this.value.email,
      ewsUrl: this.value.ewsUrl,
    };
  }

  /**
   * Render specific content.
   */
  protected renderContent() {
    return html`
      <div class="rules-form-container">
        <gz-form-field
          id="exchange-antimalware-username-form-field"
          class="label-mw-250"
          label="${translateFn('Username')}"
          required
        >
          <gz-input
            gz-form-input
            inputWidth="${InputWidthValues.LARGE}"
            placeholder="${translateFn('Enter username')}"
          ></gz-input>
          <gz-input-error></gz-input-error>
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}"
            >${translateFn(
              'Enter the user name and domain used to authenticate (for example, user@domain or DOMAIN\\user).'
            )}
          </gz-text>
        </gz-form-field>

        <gz-form-field
          id="exchange-antimalware-password-form-field"
          class="label-mw-250"
          label="${translateFn('Password')}"
          required
        >
          <gz-input
            gz-form-input
            type="password"
            inputWidth="${InputWidthValues.LARGE}"
            placeholder="${translateFn('Enter password')}"
          ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id="exchange-antimalware-email-form-field" class="label-mw-250" label="${translateFn('Email')}">
          <gz-input
            gz-form-input
            inputWidth="${InputWidthValues.LARGE}"
            placeholder="${translateFn('Enter the email address')}"
          ></gz-input>
          <gz-input-error></gz-input-error>
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}"
            >${translateFn(
              'Enter the email address of the account to be used for scanning. It can usually be determined based on the username.'
            )}
          </gz-text>
        </gz-form-field>

        <gz-form-field
          id="exchange-antimalware-ews-url-form-field"
          class="label-mw-250"
          label="${translateFn('EWS URL')}"
        >
          <gz-input
            gz-form-input
            inputWidth="${InputWidthValues.LARGE}"
            placeholder="${translateFn('Enter the URL')}"
          ></gz-input>
          <gz-input-error></gz-input-error>
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.NORMAL}"
            >${translateFn('The EWS URL is necessary when the Exchange Autodiscovery does not work.')}
          </gz-text>
        </gz-form-field>
      </div>
    `;
  }
}
